<template>
  <v-card class="request-dashboard-card">
    <section class="request-stats-grid oms-list-stats">
      <StatCard
        class="request-stat-card request-stat-card--total oms-list-stat-card"
        label="Total Requests"
        :value="dashboard.totalData"
        icon="dashboard"
        variant="primary"
      />
      <StatCard
        class="request-stat-card request-stat-card--open oms-list-stat-card"
        label="Open Requests"
        :value="dashboard.openRequest"
        icon="hourglass_empty"
        variant="yellow"
      />
      <StatCard
        class="request-stat-card request-stat-card--closed oms-list-stat-card"
        label="Closed Requests"
        :value="dashboard.closeRequest"
        icon="check_circle"
        variant="green"
      />
    </section>
  </v-card>
</template>
<script>
import StatCard from "@/components/Common/StatCard";

export default {
  props: ["dashboard"],
  components: {
    StatCard,
  },
  data() {
    return {};
  },
};
</script>
<style scoped>
.dashboard {
  padding: 20px;
  margin: 0 auto;
}
.breakword {
  padding: 10px;
}
</style>
